/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { h, createApp } from 'vue';
import qcreateApp from '../.quasar/app.js';
import singleSpaVue from 'single-spa-vue';
import {Quasar, useQuasar} from 'quasar';
import quasarUserOptions from '../.quasar/quasar-user-options';
import App from './App.vue';
import IodineGrouperService from 'src/services/IodineGrouperService';
import 'quasar/dist/quasar.sass'


let routerInstance;
qcreateApp(createApp, quasarUserOptions).then(({ router }) => {
  routerInstance = router;
});

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App);
    },
  },
  handleInstance(app) {
    app.use(Quasar, quasarUserOptions);
    app.use(routerInstance);

    app.config.errorHandler = (err, vm, info) => {
      this.printErrorMessage(err.stack);

      console.error('Error:', err);
      console.error('Vue component:', vm);
      console.error('Additional info:', info);
    };

    window.addEventListener("error", (event) => {
      const textContent = `${event.type}: ${event.message}`;
      this.printErrorMessage(textContent);

      console.error(event);
    });
  },
  printErrorMessage(message) {
    const $q = useQuasar()
    $q.dialog({
      color: 'white',
      html: true,
      title: `Sorry something went wrong.`,
      message: `<div style="padding: 10px; word-break: break-all;">Error: ${message}</div>`,
      ok: {
        class: 'dialog-button',
        label: 'Close'
      },
    });
  }
  // replaceMode: false
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
export const iodineGrouperService = IodineGrouperService;
